export default "__VITE_ASSET__D4xvg3A3__"